module.exports = __webpack_public_path__ + "img/pallet-tracking.b7a9e0db.svg";